<template>
  <div :class="styleClass"
       class="pointer"
  >
    <vue-dropzone ref="myVueDropzone"
                  id="dropzone"
                  @vdropzone-sending="beforeUpload"
                  @vdropzone-success="afterUploadSuccess"
                  @vdropzone-error="afterUploadError"
                  @vdropzone-file-added="afterFileAdded"
                  :duplicate-check="true"
                  :options="dropzoneOptions"
                  :use-custom-slot="true"
    >
      <template v-if="src && !addingFile">
        <i class="fa fa-pencil" aria-hidden="true" />
        <i class="fa fa-icon" aria-hidden="true" @click.stop="deleteImage">
          <span class="mod-icon-clear" />
        </i>
      </template>
      <template v-else-if="!addingFile">
        <div class="file-upload-wrapper">
          <div>
            <div>
              <i class="fa fa-upload" />
            </div>
            <div>
              <label v-dompurify-html="label" />
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <!-- Show any html so the default html from dropzone package is hidden -->
        <div />
      </template>
    </vue-dropzone>
    <div class="error-text">{{ error }}</div>
  </div>
</template>

<script>
import axios from 'axios';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import store from 'store';
import toastr from 'toastr';
import Errors from '../classes/Errors';

export default {
  components: {
    vueDropzone: vue2Dropzone,
  },
  props: {
    label: { type: String, default: 'Browse' },
    src: { type: Object, default: () => {} },
    styleClass: { type: String, default: 'rectangle-upload ' },
    typeId: { type: Number, default: null },
    model: { type: String, default: '' },
    modelId: { type: Number, default: null },
    recommended: { type: String, default: '' },
  },
  data() {
    return {
      fd: [],
      dropzoneOptions: {
        url: `${process.env.API_URL}${this.model}/${this.modelId}/files`,
        headers: { Authorization: `Bearer ${store.get('jwtToken')}` },
        thumbnailWidth: null,
        maxFilesize: 8,
        paramName: 'file',
        createImageThumbnails: false,
        acceptedFiles:
          'application/pdf, ' +
          'text/plain, ' +
          'application/msword, ' +
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document, ' +
          'application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, ' +
          'image/gif, ' +
          'image/png, ' +
          'image/jpg, ' +
          'image/jpeg, ' +
          'video/x-msvideo, ' +
          'video/mpeg, ' +
          'video/mp4, ' +
          'video/x-ms-wmv, ' +
          'video/avi, ' +
          'application/x-troff-msvideo, ' +
          'video/msvideo, ' +
          'video/x-mpeg, ' +
          'audio/mpeg, ' +
          'audio/x-ms-wma, ' +
          'audio/x-mpeg-3, ' +
          'audio/mpeg3, ' +
          'video/x-mpeg, ' +
          'audio/x-mpeg-3, ' +
          'audio/mp3, ',
      },
      addingFile: false,
      error: '',
      errors: new Errors(),
    };
  },
  methods: {
    beforeUpload(file, xhr, formData) {
      if (this.typeId) {
        formData.append('type_id', this.typeId);
      }
    },
    afterUploadSuccess(file) {
      this.$emit('update', this.typeId);
      this.$refs.myVueDropzone.removeFile(file);
      this.addingFile = false;
    },
    afterUploadError(file, message) {
      if (message.error) {
        toastr.error(file.name, message.error.image[0]);
      } else {
        toastr.error(file.name, message);
      }

      this.$refs.myVueDropzone.removeFile(file);
      this.addingFile = false;
    },
    afterFileAdded() {
      this.addingFile = true;
    },
    afterQueueComplete() {
      this.$refs.myVueDropzone.removeAllFiles();
      this.addingFile = false;
    },
    deleteImage() {
      const url = `${process.env.API_URL}${this.model}/${this.modelId}/files/${this.src.id}`;
      axios.delete(url).then(() => {
        toastr.success('Successfully deleted file');
        this.$emit('update', this.typeId);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ClaimFileUpload.vue